import React from 'react';
import PropTypes from 'prop-types';
import { propTypes } from '../../../../util/types';
import { FormattedMessage } from '../../../../util/reactIntl';
import { Reviews } from '../../../../components';
import classNames from 'classnames';

import ProfileNavReviewsForm from './ProfileNavReviewsForm';
import css from './ProfileNavReviewsPanel.module.css';

const ProfileNavReviewsPanel = props => {
  const {
    rootClassName,
    className,
    currentUser,
    isCurrentUser,
    userReviews,
    fetchUserReviewsInProgress,
    fetchUserReviewsError,
    sendReviewInProgress,
    sendReviewError,
    reviewSubmitted,
    onSendReview,
  } = props;

  const classes = classNames(rootClassName || css.root, className);

  // Show review form if the current user is not the user whose profile is being viewed
  const showReviewForm = currentUser && !isCurrentUser;
  const reviewForm = showReviewForm ? (
    <ProfileNavReviewsForm
      sendReviewInProgress={sendReviewInProgress}
      sendReviewError={sendReviewError}
      reviewSent={reviewSubmitted}
      onSubmit={onSendReview}
    />
  ) : null;

  // Render the appropriate review content based on the current state
  const renderReviewsContent = () => {
    if (fetchUserReviewsInProgress) {
      return (
        <p className={css.loading}>
          <FormattedMessage id="ProfileNavReviewsPanel.loadingReviews" />
        </p>
      );
    }
    if (fetchUserReviewsError) {
      return (
        <p className={css.error}>
          <FormattedMessage id="ProfileNavReviewsPanel.loadingReviewsFailed" />
        </p>
      );
    }

    if (userReviews.length > 0) {
      return <Reviews rootClassName={css.reviews} reviews={userReviews} />;
    }

    return (
      <p className={css.noReviews}>
        <FormattedMessage id="ProfileNavReviewsPanel.noReviews" />
      </p>
    );
  };

  const reviews = renderReviewsContent();

  return (
    <div className={classes}>
      {reviewForm}
      {reviews}
    </div>
  );
};

ProfileNavReviewsPanel.defaultProps = {
  rootClassName: null,
  className: null,
  currentUser: null,
  isCurrentUser: false,
  userReviews: [],
  fetchUserReviewsInProgress: false,
  fetchUserReviewsError: null,
  sendReviewInProgress: false,
  sendReviewError: null,
  reviewSubmitted: null,
  onSendReview: null,
};

const { arrayOf, string, bool, func } = PropTypes;

ProfileNavReviewsPanel.propTypes = {
  rootClassName: string,
  className: string,
  currentUser: propTypes.currentUser,
  isCurrentUser: bool.isRequired,
  userReviews: arrayOf(propTypes.userReview).isRequired,
  fetchUserReviewsInProgress: bool.isRequired,
  fetchUserReviewsError: propTypes.error,
  sendReviewInProgress: bool.isRequired,
  sendReviewError: propTypes.error,
  reviewSubmitted: bool.isRequired,
  onSendReview: func.isRequired,
};

export default ProfileNavReviewsPanel;
